export const GET_CASE = 'GET_CASE';
export const UPSERT_CASE = 'UPSERT_CASE';
export const QUERY_CASES = 'QUERY_CASES';
export const EXECUTE_CASE_ACTION = 'EXECUTE_CASE_ACTION';
export const REDUCE_QUERY_ELEMENT = 'REDUCE_CASES_QUERY_ELEMENT';
export const REDUCE_CASES = 'REDUCE_CASES';
export const REDUCE_CASE = 'REDUCE_CASE';
export const REDUCE_CASE_ELEMENT = 'REDUCE_CASE_ELEMENT';
export const REDUCE_ENTITY = 'REDUCE_ENTITY';
